<template>
  <div id="app">
    <!-- <router-link to="home">Home</router-link>/
    <router-link to="about">About</router-link>-->
    <!-- {{newName}} -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <portal-target name="mask" multiple></portal-target>
    <portal-target name="maskUpload"></portal-target>
    <portal-target name="maskDefaultFirmware"></portal-target>
  </div>
</template>

<script>
import {
  isElectron,
  isChromeOS,
  isWeb,
  isValidBrowser
} from "./assets/deviceChecker";
const { version } = require("../package.json");

export default {
  created() {
    document.title = `FlipCode ${version}`;
  },
  mounted() {
    //git commit 的前7碼
    console.log(
      "%c%s",
      "color: green; background: yellow; font-size: 24px;",
      `version:${VERSION}`
    );
    // 先判斷electron
    switch (isElectron) {
      case true:
        console.log("是electron");
        //check driver
        const checkDreiverHandler = require("./assets/driverChecker/driverChecker")
          .checkDreiverHandler;
        checkDreiverHandler();
        break;
      case false:
        console.log("不是electron");
        break;
    }
    //再判斷chromeOS
    switch (isChromeOS) {
      case true:
        console.log("是 chromeOS");
        break;
      case false:
        console.log("不是 chromeOS");
        break;
    }
    //再判斷 web
    switch (isWeb) {
      case true:
        console.log("是 win/mac web");
        break;
      case false:
        console.log("不是 win/mac web");
        break;
    }

    if (isElectron || isValidBrowser) {
      console.log("是electron 或是合格的瀏覽器");
    } else {
      console.log("不是electron 且 不是合格瀏覽器");
      alert("Please use Chrome with version78 or above");
    }
  }
};
</script>




<style lang="scss">
@mixin svgStyle {
  background-size: cover;
  background-position: center center;
  height: 24px;
  width: 24px;
  margin-right: 7px;
}

#app {
  font-family: Arial, Helvetica, sans-serif !important;
  text-align: center;
  color: #2c3e50;
  min-width: 925px;
  overflow: hidden;
}
.connectSuccess-svg {
  background-image: url("./assets/connectSuccess.svg");
  @include svgStyle;
}
.finish-svg {
  background-image: url("./assets/finish.svg");
  @include svgStyle;
}
.error-svg {
  background-image: url("./assets/error.svg");
  @include svgStyle;
}
.loading-svg {
  background-image: url("./assets/loading.svg");
  @include svgStyle;
  animation: rotate 1.5s linear infinite;
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
}
.reconnectSuccess-svg {
  background-image: url("./assets/reconnectSuccess.svg");
  @include svgStyle;
}
.reconnectFail-svg {
  background-image: url("./assets/reconnectFail.svg");
  @include svgStyle;
}

.blocklyToolboxDiv {
  background-color: white;
  box-shadow: 4px 0 7px rgba(0, 0, 0, 0.05);
  width: 200px;
}

.groupTreeItem {
  .blocklyTreeRow {
    border-left: 8px solid transparent !important;
  }
}

@for $i from 10 through 15 {
  .groupTreeItem:nth-of-type(#{$i}) {
    & > .blocklyTreeRow > .blocklyTreeIcon {
      $base: -1;
      $offsetBase: $i - 10;
      $offsetWithoutBase: $offsetBase * -16;
      $offset: $base + $offsetWithoutBase;
      background-image: url("./assets/custom_blue_sprites.png");
      background-position: -32px $offset + unquote("px");
      margin-left: -8px;
      margin-right: 8px;
    }
  }

  .groupTreeItem:nth-of-type(17) {
    & > .blocklyTreeRow > .blocklyTreeIcon {
      background-image: url("./assets/custom_redSerial_circle.png");
      background-position: -18px -4px;
      margin-left: -8px;
      margin-right: 8px;
    }
  }
}
</style>
